/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import React from "react"
import {useSelector, useDispatch} from "react-redux"

import {
    selectErrorForErrorReport,
    selectIsErrorReportVisible,
} from "./redux/errorReport.selector"
import {hideErrorReport} from "./redux/errorReport.actions"
import ErrorReport from "../../@biocrates-common-repo/core/components/error-report/ErrorReport"
import Error from "../../@biocrates-common-repo/core/models/error"

export default function ErrorReportWrapper() {
    const dispatch = useDispatch()
    const isOpen: boolean = useSelector(selectIsErrorReportVisible)
    const error: Error | undefined = useSelector(selectErrorForErrorReport)

    const closeAction = (): void => {
        dispatch(hideErrorReport())
    }

    return <ErrorReport isOpen={isOpen} error={error} onClose={closeAction} />
}
